import Icon, { FileTextOutlined, UserOutlined } from "@ant-design/icons";
import { Avatar } from "antd";
import { useMemo } from "react";
import { IoLockClosedSharp } from "react-icons/io5";
import { LuAlarmClock } from "react-icons/lu";
import { SiMinutemailer } from "react-icons/si";
import { conversationType } from "../../config/Constant";
import { ReceiveEmail } from "../../config/Icon";
import { useMenuContext } from "../../context/MenuContext";
import { useInfoUser } from "../../store/UserStore";
import { CustomAvatar } from "./CustomAvatar";
import OverlappedAvatars from "./OverlappedAvatars";
import { MemberAvatar } from "./ProfileAvatar";

const AvatarComponent = ({ conversation }) => {
  const { user } = useInfoUser();
  const { selectedConversation } = useMenuContext();

  const showPrefixIcon = useMemo(() => {
    switch (conversation?.type) {
      case conversationType.NOTIFICATION:
        if (conversation?.role === "HOST") {
          return <SiMinutemailer color="#32a5d8" size={32} />;
        } else {
          return <Icon component={ReceiveEmail} className="text-[32px]" />;
        }
      case conversationType.PERSONAL:
        const member = {
          avatar: conversation?.avatar,
          name: conversation?.name,
          userId: conversation?.memberList?.filter((e) => e !== user?.userId),
        };

        return <MemberAvatar person={member} size={50} onlineSize={null} />;
      case conversationType.SYSTEM:
      case conversationType.SELF:
        const person = {
          avatar: conversation?.avatar,
          name: conversation?.name,
          userId: conversation?.memberList?.filter((e) => e !== user?.userId),
        };

        return (
          <CustomAvatar
            person={person}
            userId={person?.userId}
            size={50}
            pos={-1}
            styleCss={{}}
          />
        );
      case conversationType.GROUP:
        if (conversation?.conversationStatus === "INACTIVE")
          return <IoLockClosedSharp color="#5d5555" />;

        return (
          <OverlappedAvatars
            conversationAvatar={conversation?.avatar}
            images={conversation?.members}
            totalMember={conversation?.totalMember}
          />
        );
      case conversationType.DRAFT:
        return <FileTextOutlined />;
      case conversationType.SCHEDULE:
        return <LuAlarmClock />;
      default:
        return <UserOutlined />;
    }
  }, [conversation]);

  const getBgColorAvatar = useMemo(() => {
    switch (conversation?.type) {
      case conversationType.NOTIFICATION:
        return "bg-[white]";
      case conversationType.GROUP:
        if (
          conversation?.conversationStatus === "ACTIVE" &&
          conversation?.conversationId === selectedConversation?.conversationId
        )
          return "bg-[#eaeef0]";

        if (conversation?.conversationStatus === "ACTIVE") return "bg-[white] ";
        return "bg-[#c1c9cd]";
      case conversationType.DRAFT:
        return "bg-[#0B6478]";
      case conversationType.SCHEDULE:
        return "bg-[#2a56b9]";
      default:
        return "bg-[white] ";
    }
  }, [conversation]);

  return (
    <Avatar size={50} className={getBgColorAvatar} icon={showPrefixIcon} />
  );
};

export default AvatarComponent;
